module.exports = __webpack_public_path__ + "img/benefit-04-camera-2.b2433860.png";